import { useMemo } from 'react';

import { Job } from 'src/types/gojob';

const useComputerSkills = (job?: Job) => {
  return useMemo(() => {
    return (job?.computerSkills || []).map((skill) => {
      return { value: skill };
    });
  }, [job?.computerSkills]);
};

export default useComputerSkills;
